/* eslint-disable max-statements */
import React from 'react';
import Modal from 'src/Components/PopupModal_V2';
import styles from './styles.module.scss';
import TableData from './Components/TableData';
import Button from 'src/Components/Button_V2';
import SelectionInfo from './Components/SelectionInfo';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { CurrencyType } from '@wolffun/system-currency';
import { checkInvalidPrice, getTotalPrices } from '../utils';
import { makeSelectCurrentTotalItems } from './Components/TableData/selectors';
import { searchAvailableHeroInventory } from 'src/redux/actions';
import icEmpty from 'assets/img/ic_empty.png';
import { navigateToMarketplace } from 'src/utils/navigate';
import { SearchParamsSortOption } from 'src/models';
import { normaliseSearchUrl } from 'src/utils/query';
import { ITEM_PER_PAGE, MAX_QUICK_SELECT, MIN_DISPLAY_QUICK_SELECT } from './constants';
import Spinner from 'src/Components/Spinner';
import EmptyList from 'src/Components/EmptyList';
import PageContent from 'src/Components/PageContent';
import { AppError } from 'src/redux/types';

const ChooseHeroModal = ({
  onClose,
  onChooseHeroComplete,
  tokenIdsSelected = []
}) => {
  const dispatch = useTypedDispatch();
  const [tokenIdList, setTokenIdList] = React.useState([]);

  const getTokenIdList = list => {
    setTokenIdList(list);
  };

  const [selectAllOption, setSelectAllOption] = React.useState();
  const [totalHeroesInventory, setTotalHeroInventory] = React.useState(0);
  const quickSelectNumber = Math.min(totalHeroesInventory, MAX_QUICK_SELECT);
  const [paramsSearch, setParamsSearch] = React.useState();
  const thgBalance = useTypedSelector(state => state.connectWallet.thgBalance) || {
    token: CurrencyType.THG,
    value: '0'
  };
  const thgPerHero = useTypedSelector(state => {
    var _state$stakingConfig$;

    return (_state$stakingConfig$ = state.stakingConfig.data) === null || _state$stakingConfig$ === void 0 ? void 0 : _state$stakingConfig$.thgPerHero;
  }) || {
    token: CurrencyType.THG,
    value: '0'
  };
  const numberSelected = selectAllOption ? quickSelectNumber : tokenIdList.length;
  const totalPrice = getTotalPrices(numberSelected, thgPerHero);
  const invalidPrice = checkInvalidPrice(totalPrice, thgBalance);
  const [hasResetSelected, setHasResetSelected] = React.useState(false);
  React.useEffect(() => {
    setHasResetSelected(false);
  }, [hasResetSelected]);
  const totalItems = useTypedSelector(makeSelectCurrentTotalItems);
  const loading = useTypedSelector(state => state.availableHeroInventoryResults.loading);
  const invalidated = useTypedSelector(state => state.availableHeroInventoryResults.invalidated);
  const error = useTypedSelector(state => state.availableHeroInventoryResults.error);
  React.useEffect(() => {
    dispatch(searchAvailableHeroInventory({
      from: 0,
      size: ITEM_PER_PAGE,
      market: true,
      status: 3,
      sort: SearchParamsSortOption.GTHC_BATTLES,
      desc: true
    }));
  }, []);

  const onQuickSelectAllHeroes = () => {
    if (paramsSearch) setSelectAllOption({
      isSelectAllTokens: true,
      sort: paramsSearch.sort,
      desc: paramsSearch.desc
    });
  };

  const renderLoading = () => {
    return /*#__PURE__*/React.createElement(Modal, {
      onClose: onClose,
      className: styles.empty
    }, /*#__PURE__*/React.createElement(Spinner, null), ";");
  };

  const renderError = () => {
    return /*#__PURE__*/React.createElement(Modal, {
      onClose: onClose,
      className: styles.empty
    }, /*#__PURE__*/React.createElement(EmptyList, {
      title: "Sorry, something went wrong.",
      content: "Please try again.",
      className: styles.empty
    }));
  };

  const renderContent = () => {
    return totalItems === 0 ? renderNoHeroesModal() : renderChooseHeroModal();
  };

  const renderNoHeroesModal = () => {
    return /*#__PURE__*/React.createElement(Modal, {
      onClose: onClose,
      className: styles.empty
    }, /*#__PURE__*/React.createElement("img", {
      className: styles.icon,
      src: icEmpty
    }), /*#__PURE__*/React.createElement("span", {
      className: styles.title
    }, "You don't have any heroes"), /*#__PURE__*/React.createElement("span", {
      className: styles.content
    }, /*#__PURE__*/React.createElement("span", null, "Please go to the marketplace and buy NFT heroes to be able to stake")), /*#__PURE__*/React.createElement(Button, {
      title: "Buy Heroes to Stake",
      type: "warning",
      onClick: () => {
        const searchParam = {
          batPercentMax: 20,
          batPercentMin: 0,
          sort: SearchParamsSortOption.PRICE_ASC
        };
        navigateToMarketplace(normaliseSearchUrl(searchParam));
      }
    }));
  };

  const renderChooseHeroModal = () => {
    return /*#__PURE__*/React.createElement(Modal, {
      onClose: onClose,
      header: "Choose heroes",
      className: styles.modal
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.message
    }, "Heroes that are selling, renting, or being rented are not displayed in the list below."), /*#__PURE__*/React.createElement("span", {
      className: styles.note
    }, "Staked NFT heroes will be removed from your inventory"), /*#__PURE__*/React.createElement("div", {
      className: styles.countSelected
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.counted
    }, "Selected ", numberSelected, " Heroes"), quickSelectNumber >= MIN_DISPLAY_QUICK_SELECT && /*#__PURE__*/React.createElement("span", {
      className: styles.quickSelect,
      onClick: onQuickSelectAllHeroes
    }, /*#__PURE__*/React.createElement("span", null, quickSelectNumber < MAX_QUICK_SELECT ? `Select ${quickSelectNumber} Heroes` : `Quick select the first ${quickSelectNumber} heroes`)), /*#__PURE__*/React.createElement("div", {
      className: styles.empty
    }), numberSelected > 0 && /*#__PURE__*/React.createElement("span", {
      className: styles.clear,
      onClick: () => {
        setHasResetSelected(true);
        setSelectAllOption(undefined);
      }
    }, "Clear all")), /*#__PURE__*/React.createElement(TableData, {
      getTokenIdList: getTokenIdList,
      hasResetSelected: hasResetSelected,
      tokenIdsSelected: tokenIdsSelected,
      getTotalHeroesInventory: total => setTotalHeroInventory(total),
      getParamsSearch: (sort, desc) => {
        setParamsSearch({
          sort,
          desc
        });
      },
      hasQuickSelect: !!selectAllOption
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.sticky
    }, /*#__PURE__*/React.createElement(SelectionInfo, {
      numberSelected: numberSelected,
      totalPrice: totalPrice,
      thgBalance: thgBalance,
      isInvalidPrice: invalidPrice
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.btnGroup
    }, /*#__PURE__*/React.createElement(Button, {
      title: `Clear All (${numberSelected})`,
      type: "outlined",
      onClick: () => {
        setHasResetSelected(true);
        setSelectAllOption(undefined);
      },
      className: styles.btnClear
    }), /*#__PURE__*/React.createElement(Button, {
      title: "Apply",
      type: "warning",
      onClick: () => onChooseHeroComplete(tokenIdList, selectAllOption, numberSelected),
      disabled: invalidPrice || numberSelected == 0
    }))));
  };

  return /*#__PURE__*/React.createElement(PageContent, {
    invalidated: invalidated,
    loading: loading,
    error: error !== AppError.NO_ERROR,
    renderContent: renderContent,
    renderLoading: renderLoading,
    renderError: renderError
  });
};

export default ChooseHeroModal;